import { UploadWorkspaceImageDto } from '@app/shared/dto';
import { createAction, props } from '@ngrx/store';

// Upload Image
export const uploadImage = createAction('[Workspace] Upload image', props<{ payload: UploadWorkspaceImageDto }>());
